angular.module('impactx.product').service('ProductSelectionService', ProductSelectionService);

ProductSelectionService.$inject = ['DialogPanelService'];

function ProductSelectionService(DialogPanelService)
{
    // var docConfig = {
    //     title: 'title', // title of the dialog panel
    //     locals: {
    //         hideDefaultAction: false, // hides the default "select" and "select all" actions
    //         useMultiSelect: false, // set to true if multiple products should be selectable
    //         hideFilters: false, // set to true to hide default filters
    //         usevcatfilter: true, // set to true to enable the vcat-filter, if false the vcat-filter is fixed
    //         vcatFilterEntryPoint: 'some/entrypoint', // the entrypoint to get the vcatfilter values from (only necessary if usevcatfilter is true)
    //         vcat: {
    //             id: 1 // the preselected value for the vcatfilter
    //         },
    //         itemActions: [ // array of custom actions shown on every item
    //             {
    //                 action: someAction, // the action to perform
    //                 label: 'label', // the label shown
    //                 closeAfter: true, // set to true if the DialogPanel should be closed after performing the action
    //                 reloadAfter: true, // set to true if the DialogPanel should reload after performing the action (closeAfter > reloadAfter)
    //                 condition: conditionFunctionOrValue // a condition-function or -value that determines if the action-button is shown
    //             }
    //         ],
    //         listActions: [ // array of custom actions shown at the top of the list
    //             {
    //                 action: someAction,
    //                 label: 'label',
    //                 closeAfter: true,
    //                 reloadAfter: true,
    //                 condition: conditionFunctionOrValue
    //             }
    //         ],
    //         cscId: 0 // optional for invoice product selection to receive product with price
    //         ctxUsrId: 0 // optional id of the alternate user, whose context should be used for the search
    //         rfqhId: 0 // for additional filtering of products
    //     },
    //     controller: 'SomeCtrl', // the controller to use
    //     controllerAs: 'someCtrl',
    //     templateUrl: 'templates/some.tmpl.html', // the template shown
    //     targetEvent: event // the target event
    // };
    
    var defaultConfig = {
        title: undefined,
        locals: {},
        controller: 'ProductSelectionListCtrl',
        controllerAs: 'productSelectionListCtrl',
        templateUrl: 'modules/product/templates/productselectionlist.tmpl.html',
        targetEvent: undefined
    };
    
    var open = function(config) {
        var merged = angular.extend({}, defaultConfig, config);
        return DialogPanelService.open(merged);
    };
    
    return {
        open : open
    };
}